import { Reveal, Eyebrow } from "./Reveal";
import { SectionMedia } from "./SectionMedia";
import { useApp } from "../store";

export const Methodology = () => {
  const { c, t } = useApp();

  return (
    <section id="methode" data-testid="methodology-section" className="relative text-white grain" style={{ background: "var(--sec-methode-bg, #0A1428)" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32 relative z-10">
        <Reveal className="max-w-2xl mb-16">
          <Eyebrow>{t("method_eyebrow")}</Eyebrow>
          <h2 data-testid="methodology-title" className="mt-5 font-display font-semibold text-2xl sm:text-3xl lg:text-4xl tracking-tight">
            {t("method_title")}
          </h2>
          <p className="mt-4 text-sm sm:text-base text-white/60 leading-relaxed">{t("method_sub")}</p>
        </Reveal>

        <div className="relative">
          <div className="absolute left-[19px] sm:left-1/2 top-0 bottom-0 w-px bg-[var(--accent-soft)]/10" aria-hidden="true" />
          <div className="flex flex-col gap-12 sm:gap-16">
            {[1, 2, 3, 4, 5].map((n, i) => (
              <Reveal key={n} delay={0.05 * i}>
                <div
                  data-testid={`methodology-step-${n}`}
                  className={`relative flex items-start gap-6 sm:gap-0 ${
                    i % 2 === 0 ? "sm:flex-row" : "sm:flex-row-reverse"
                  }`}
                >
                  <div className={`sm:w-1/2 pl-14 ${i % 2 === 0 ? "sm:pl-0 sm:pr-16 sm:text-right" : "sm:pl-16"}`}>
                    <h3 className="font-display font-semibold text-xl sm:text-2xl">
                      {c(`step_${n}_title`)}
                    </h3>
                    <p className={`mt-2 text-sm sm:text-base text-white/60 leading-relaxed ${i % 2 === 0 ? "sm:ml-auto" : ""} max-w-sm`}>
                      {c(`step_${n}_desc`)}
                    </p>
                  </div>
                  <span className="absolute left-0 sm:left-1/2 sm:-translate-x-1/2 w-10 h-10 grid place-items-center rounded-full bg-white/[0.05] border border-[var(--accent)]/50 font-mono2 text-xs text-[var(--accent-soft)]">
                    0{n}
                  </span>
                  <div className="hidden sm:block sm:w-1/2" />
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <SectionMedia section="methode" />
      </div>
    </section>
  );
};
